type UserAnalyticsOnboardingSessionStatus =
  | "DRAFT"
  | "READY"
  | "RUNNING"
  | "PREVIEW_READY"
  | "FAILED"
  | "APPLIED";

type UserAnalyticsSetupStatus =
  | "hidden"
  | "not_started"
  | "in_progress"
  | "resumable"
  | "preview_ready_next_action"
  | "completed";

type SetupStatusSession = {
  status: string;
  latestSnapshotID?: string | null;
  projectID?: string | null;
} | null;

const PREVIEW_READY_STATUSES = new Set<UserAnalyticsOnboardingSessionStatus>([
  "PREVIEW_READY",
]);

const IN_PROGRESS_STATUSES = new Set<UserAnalyticsOnboardingSessionStatus>([
  "DRAFT",
  "READY",
  "RUNNING",
]);

/**
 * User Analytics 初期分析 session を、sidebar の再開導線と空状態 CTA が共有できる状態語彙へ変換します。
 * UA も SA と同じ badge/cancel UX を使うため、GraphQL enum を UI lifecycle に丸めます。
 */
export function deriveUserAnalyticsSetupStatus({
  session,
}: {
  session?: SetupStatusSession;
}): UserAnalyticsSetupStatus {
  if (!session) {
    return "not_started";
  }

  const sessionStatus = session.status as UserAnalyticsOnboardingSessionStatus;

  if (sessionStatus === "APPLIED") {
    return "completed";
  }

  if (sessionStatus === "FAILED") {
    return "resumable";
  }

  if (PREVIEW_READY_STATUSES.has(sessionStatus) || session.latestSnapshotID) {
    return "preview_ready_next_action";
  }

  if (IN_PROGRESS_STATUSES.has(sessionStatus)) {
    return "in_progress";
  }

  return "hidden";
}

/**
 * Sidebar の初期分析行に「未完了」バッジを出すべき UA 状態を判定します。
 * `not_started` は行自体を表示しないため badge 対象から外します。
 */
export function shouldShowUserAnalyticsSetupBadge(
  status: UserAnalyticsSetupStatus,
) {
  return (
    status === "in_progress" ||
    status === "resumable" ||
    status === "preview_ready_next_action"
  );
}
